module.exports = __webpack_public_path__ + "img/auth-illustration.0cdd8c1a.svg";